import React, { useState } from 'react';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import { KeyboardArrowDownIcon } from 'icons/materialIcons';
import LeadsOverTimeChartJS from '../../../components/insights/charts/LeadsOverTimeChartJS';
import ViewsOverTimeChartJS from '../../../components/insights/charts/ViewsOverTimeChartJS';
import ActiveMembersOverTimeChartJS from './charts/ActiveMembersOverTimeChartJS';

const CHART_OPTIONS = [
    { value: 'leads', label: 'Leads' },
    { value: 'views', label: 'Views' },
    { value: 'activeMembers', label: 'Active Members' }
];

const TeamChartWithDropdown = ({
    leadsData,
    viewsData,
    activeTeamMembersCount,
    members = []
}) => {
    const [selectedChart, setSelectedChart] = useState('leads');
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChartSelect = (chartType) => {
        setSelectedChart(chartType);
        handleClose();
    };

    // Render dropdown component - heading with dropdown menu
    const renderDropdown = () => (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    gap: '5px',
                    '&:hover': {
                        opacity: 0.8
                    }
                }}
                onClick={handleClick}
            >
                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        color: '#333333'
                    }}
                >
                    {CHART_OPTIONS.find(opt => opt.value === selectedChart)?.label || 'Leads'} Over Time
                </Typography>
                <KeyboardArrowDownIcon
                    sx={{
                        fontSize: 16,
                        color: '#828282',
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s'
                    }}
                />
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        minWidth: '180px',
                        mt: 1
                    }
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                {CHART_OPTIONS.map((option) => (
                    <MenuItem
                        key={option.value}
                        onClick={() => handleChartSelect(option.value)}
                        sx={{
                            fontSize: '14px',
                            fontWeight: selectedChart === option.value ? 600 : 400,
                            color: selectedChart === option.value ? '#29AEF8' : '#4F4F4F',
                            py: 1.5,
                            '&:hover': {
                                backgroundColor: '#F7F7F7'
                            }
                        }}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );

    const renderChart = () => {
        const dropdownElement = renderDropdown();

        switch (selectedChart) {
            case 'leads':
                return <LeadsOverTimeChartJS data={leadsData?.overTime || []} dropdown={dropdownElement} />;
            case 'views':
                return <ViewsOverTimeChartJS data={viewsData?.overTime || []} dropdown={dropdownElement} />;
            case 'activeMembers':
                return <ActiveMembersOverTimeChartJS data={members} dropdown={dropdownElement} />;
            default:
                return <LeadsOverTimeChartJS data={leadsData?.overTime || []} dropdown={dropdownElement} />;
        }
    };

    return (
        <Box sx={{ marginTop: '24px' }}>
            {renderChart()}
        </Box>
    );
};

export default TeamChartWithDropdown;

